// extracted by mini-css-extract-plugin
module.exports = {"shareScreenFull":"shareScreenFull___2sLts","icon":"icon___d_6Ve","tooltip":"tooltip___2ur6l"};